
import { Options, Vue } from 'vue-class-component'
import QInput from 'quasar/src/components/input/QInput.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QForm from 'quasar/src/components/form/QForm.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import CustomerProfiles, { CustomerProfilesDopa } from '@/interfaces/customer-profiles'
import { Prop } from 'vue-property-decorator'
import { useStore } from '@/store'
import * as dopaService from '@/services/line-web-loyalty-bff/v1/dopa'
import { StepEditMobile } from '@/model/step-edit-mobile.model'
import { modalOptionsDopaSubmitError } from '@/model/modal-options.model'
import { alertMessageError } from '@/model/alert-options.model'
import { isNullOrEmpty } from '@/utils/validator'

@Options({
  components: {
    QInput,
    QIcon,
    QForm,
    QBtn,
    QCheckbox
  }
})
export default class Dopa extends Vue {
  @Prop() customerProfileModel!: CustomerProfiles

  store = useStore()
  private model: CustomerProfilesDopa = {
    first_name: '',
    last_name: '',
    date_of_birth: '',
    national_id: '',
    laser: '',
    update_profile: false
  }
  private preValue: CustomerProfilesDopa = {
    date_of_birth: '',
    laser: ''
  }
  private isTooltipDateOfBirth = false
  private isTooltipLaser = false
  private refKeys = [ 'firstNameRef', 'lastNameRef', 'dateOfBirthRef', 'nationalIdRef', 'laserRef' ]
  private isSubmit = false
  private isRequiredDateOfBirth = false
  private isShowMessageDateOfBirthFormat = false
  private isRequiredLaser = false
  private isShowMessageLaserFormat = false
  private nonThaiRegex = /[^ก-๙\s-]/g
  private thaiRegex = /^[ก-๛\s-]+$/
  private thaiIntegerRegex = /[๑-๙]/g
  private thaiSpecialRegex = /฿|๐|ํ|ฺ/g
  private dateOfBirthRegex = /^(?:\d{1,2}(?:\/(?:\d{1,2}(?:\/(?:\d{1,4})?)?)?)?)$/
  private laserENRegex = /^[a-zA-Z]{1,2}$/
  private laserIntegerRegex = /^(?:\d{0,1}(?:-(?:\d{1,7}(?:-(?:\d{1,2})?)?)?)?)$/

  mounted() {
    this.bindDataToModel()
  }

  bindDataToModel() {
    let isError = []
    const keys = Object.keys(this.customerProfileModel)
    if (keys.length) {
      for (const key of keys) {
        const value = JSON.parse(JSON.stringify(this.customerProfileModel[key]))
        const readOnlyKeys = ['first_name', 'last_name', 'date_of_birth', 'national_id', 'laser']
        if (!readOnlyKeys.includes(key)) continue
        if (key === readOnlyKeys[0] || key === readOnlyKeys[1]) {
          this.model[key] = value?.trim()
          const refKey = key === readOnlyKeys[0] ? this.refKeys[0] : this.refKeys[1]
          if (!this.isThaiLanguage(this.model[key] as string)) {
            this.setRequired('', refKey)
            isError.push(key)
          }
        } else {
          this.model[key] = value
          if (key === readOnlyKeys[2]) {
            if (this.model[key]) {
              this.isValidDateOfBirthFormat(this.model[key])
              if (this.isShowMessageDateOfBirthFormat) isError.push(key)
            }
          } else {
            if (!this.model[key]) {
              this.setRequired('', this.refKeys[readOnlyKeys.indexOf(key)])
              isError.push(key)
            }
          }
        }
      }
    }

    if (isError.length === 0 && this.model.laser?.length === 14) this.isSubmit = true
  }

  isThaiLanguage(val: string): boolean {
    return val && this.thaiRegex.test(val) && !this.thaiIntegerRegex.test(val) && !this.thaiSpecialRegex.test(val) ? true : false
  }

  isValidDateOfBirthFormat(val: string) {
    this.isRequiredDateOfBirth = false
    this.isShowMessageDateOfBirthFormat = false
    if (val) {
      const dateOfBirth = val.split('/')
      if (dateOfBirth) {
        const isDay = dateOfBirth[0]?.length === 2 && parseInt(dateOfBirth[0]) >= 0 && parseInt(dateOfBirth[0]) <= 31
        const isMonth = dateOfBirth[1]?.length === 2 && parseInt(dateOfBirth[1]) >= 0 && parseInt(dateOfBirth[1]) <= 12

        const currentDate = new Date()
        currentDate.setFullYear(currentDate.getFullYear() + 543)

        const isYearBE = parseInt(dateOfBirth[2]) > 1800 && parseInt(dateOfBirth[2]) <= currentDate.getFullYear()
        if (isDay && isMonth && isYearBE) {
          const dob = new Date(parseInt(dateOfBirth[2]), parseInt(dateOfBirth[1]) - 1, parseInt(dateOfBirth[0]))
          const minDate = new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate())
          const maxDate = new Date(currentDate.getFullYear() - 15, currentDate.getMonth(), currentDate.getDate())
          if (dob < minDate || dob > maxDate) {
            this.isShowMessageDateOfBirthFormat = true
          }
        } else {
          this.isShowMessageDateOfBirthFormat = true
        }
      }
    } else {
      this.isRequiredDateOfBirth = true
    }
  }

  isValidLaserFormat(isBlur: boolean, val: string) {
    this.isRequiredLaser = false
    this.isShowMessageLaserFormat = false
    if (isBlur && val && val?.length !== 14) {
      this.isShowMessageLaserFormat = true
    } else if (!val) {
      this.isRequiredLaser = true
    }
  }

  setInputFocus(refName: string) {
    const ref: any = this.$refs[refName]
    const element = ref?.$el
    if (element) element.focus()
  }

  setRequired(val: string, refName: string) {
    const ref: any = this.$refs[refName]
    return !val ? ref?.validate() : ref?.resetValidation()
  }

  onValidationError() {
    this.isSubmit = true
    for (let key of this.refKeys) {
      const ref: any = this.$refs[key]
      if (ref?.hasError || (key === this.refKeys[4] && this.model.laser?.length !== 14)) {
        this.isSubmit = false
        this.setInputFocus(ref?.$el)
        break
      }
    }
  }

  onBlurFirstName() {
    this.model.first_name = this.model.first_name?.trim()
    if (!this.model.first_name || !this.isThaiLanguage(this.model.first_name as string)) {
      this.setRequired('', this.refKeys[0])
    }
    return this.onValidationError()
  }

  onChangeFirstName(val: string) {
    this.model.first_name = val ? val.replace(this.nonThaiRegex, '').replace(this.thaiIntegerRegex, '').replace(this.thaiSpecialRegex, '') : ''
    return this.onValidationError()
  }

  onBlurLastName() {
    this.model.last_name = this.model.last_name?.trim()
    if (!this.model.last_name || !this.isThaiLanguage(this.model.last_name as string)) {
      this.setRequired('', this.refKeys[1])
    }
    return this.onValidationError()
  }

  onChangeLastName(val: string) {
    this.model.last_name = val ? val.replace(this.nonThaiRegex, '').replace(this.thaiIntegerRegex, '').replace(this.thaiSpecialRegex, '') : ''
    return this.onValidationError()
  }

  onUpdateDOB (value: string) {
    const currentInputLength = value?.length
    const preInputLength = this.preValue.date_of_birth?.length as number

    if (!isNullOrEmpty(value) && !this.dateOfBirthRegex.test(value)) {
      this.model.date_of_birth = this.preValue.date_of_birth
      return
    }

    // To apply the condition when the input is entered only
    if (currentInputLength > preInputLength) {
      // to prevent the entering '/'
      if (value[currentInputLength - 1] === '/') {
        this.model.date_of_birth = this.preValue.date_of_birth
        return
      }
      // insert '/' at the positions
      if (currentInputLength === 2 || currentInputLength === 5) {
        this.model.date_of_birth += '/'
      }
    } else {
      // automatically remove '/' and a previous character by a single enter
      if (this.preValue.date_of_birth && this.preValue.date_of_birth[preInputLength -1] === '/') {
        this.model.date_of_birth = this.model.date_of_birth ? this.model.date_of_birth.substring(0, this.model.date_of_birth.length -1) : ''
      }
    }
    this.preValue.date_of_birth = this.model.date_of_birth
    this.validateDOB()
  }
  
  validateDOB() {
    this.isValidDateOfBirthFormat(this.model.date_of_birth as string)
    return this.onValidationError()
  }

  onShowTooltipDateOfBirth(refName: string) {
    this.setInputFocus(refName)
    this.isTooltipDateOfBirth = !this.isTooltipDateOfBirth
    this.isTooltipLaser = false
  }

  onUpdateLaser (value: string, isBlur: boolean) {
    const currentInputLength = value?.length
    const preInputLength = this.preValue.laser?.length as number
    this.model.laser = this.model.laser?.toUpperCase()

    if (!isNullOrEmpty(value) && (!this.laserENRegex.test(value.substring(0,2)) || !this.laserIntegerRegex.test(value.substring(2)))) {
      this.model.laser = this.preValue.laser
      return
    }

    // To apply the condition when the input is entered only
    if (currentInputLength > preInputLength) {
      // to prevent the entering '-'
      if (value[currentInputLength - 1] === '-') {
        this.model.laser = this.preValue.laser
        return
      }
      // insert '-' at the positions
      if (currentInputLength === 3 || currentInputLength === 11) {
        this.model.laser += '-'
      }
    } else {
      // automatically remove '-' and a previous character by a single enter
      if (this.preValue.laser && this.preValue.laser[preInputLength -1] === '-') {
        this.model.laser = this.model.laser ? this.model.laser.substring(0, this.model.laser.length -1) : ''
      }
    }
    this.preValue.laser = this.model.laser
    this.validateLaser(isBlur)
  }

  validateLaser(isBlur: boolean) {
    this.isValidLaserFormat(isBlur, this.model.laser as string)
    return this.onValidationError()
  }

  onShowTooltipLaser(refName: string) {
    this.setInputFocus(refName)
    this.isTooltipDateOfBirth = false
    this.isTooltipLaser = !this.isTooltipLaser
  }

  generateDateOfBirth(date: string) {
    let result = ''
    const dateOfBirth = date ? date.split('/') : undefined
    if (dateOfBirth) {
      const strDay = dateOfBirth[0]
      const strMonth = dateOfBirth[1]
      const strYear = parseInt(dateOfBirth[2]) - 543
      result = `${strYear}-${strMonth}-${strDay}`
    }
    return result
  }

  async submitForm() {
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', true)
    const token = this.store.state.lineInfo.idToken
    if (this.isSubmit && token) {
      this.isSubmit = false
      const requestBody = { 
        first_name: this.model.first_name,
        last_name: this.model.last_name,
        date_of_birth: this.generateDateOfBirth(this.model.date_of_birth as string),
        laser: this.model.laser?.replace(/-/g, ''),
      }
      const result = await dopaService.verifyDopa(token, requestBody)
      const statusCode = result?.json?.code
      if (statusCode === 200) {
        const { l1_token: l1Token, verified_date: verifiedDate } = result?.json?.data
        
        if (this.model.update_profile) {
          const customerProfileDopa: CustomerProfilesDopa[] = [{
            update_profile: this.model.update_profile,
            first_name: requestBody.first_name,
            last_name: requestBody.last_name,
            date_of_birth: requestBody.date_of_birth,
            verified_date: verifiedDate
          }]
          this.store.commit('modalEditMobile/updateCustomerProfileDopa', customerProfileDopa)
        }
        this.store.commit('modalEditMobile/updateL1Token', l1Token)
        this.store.commit('modalEditMobile/updateStep', StepEditMobile.INPUT_NEW_MOBILE)
      } else if (statusCode === 400 || statusCode === 401 || statusCode === 404 || statusCode === 429) {
        this.store.dispatch('modalNotification/onOpen',
          modalOptionsDopaSubmitError(() => {
            this.store.dispatch('modalNotification/onClose')
          })
        )
      } else {
        this.store.dispatch('alertMessage/onOpen', alertMessageError(statusCode))
        setTimeout(() => this.store.dispatch('alertMessage/onClose'), 3000)
      }
    }
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
    this.isSubmit = true
  }
}
